var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.55556C3.12705 2.55556 2.92922 2.6375 2.78336 2.78336C2.6375 2.92922 2.55556 3.12705 2.55556 3.33333V12.6667C2.55556 12.8729 2.6375 13.0708 2.78336 13.2166C2.92922 13.3625 3.12705 13.4444 3.33333 13.4444H9.55556V2.55556H3.33333ZM3.33333 1C2.7145 1 2.121 1.24583 1.68342 1.68342C1.24583 2.121 1 2.7145 1 3.33333V12.6667C1 13.2855 1.24583 13.879 1.68342 14.3166C2.121 14.7542 2.71449 15 3.33333 15H12.6667C13.2855 15 13.879 14.7542 14.3166 14.3166C14.7542 13.879 15 13.2855 15 12.6667V3.33333C15 2.71449 14.7542 2.121 14.3166 1.68342C13.879 1.24583 13.2855 1 12.6667 1H3.33333ZM11.1111 2.55556V13.4444H12.6667C12.8729 13.4444 13.0708 13.3625 13.2166 13.2166C13.3625 13.0708 13.4444 12.8729 13.4444 12.6667V3.33333C13.4444 3.12705 13.3625 2.92922 13.2166 2.78336C13.0708 2.6375 12.8729 2.55556 12.6667 2.55556H11.1111Z",
    fill: "#29C0BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseOut);
export default __webpack_public_path__ + "static/media/collapse-out.11eb9e46a19d035cb31755a1f13c5aa2.svg";
export { ForwardRef as ReactComponent };